export { default as HUIPhoneInput } from './hui-phone-input';
export type { HUIPhoneInputProps } from './types';
